module.exports = "/images/image2.jpg?caa80775451329eee5ce4c4a0697bde3";